import axios from "axios";
import { GRAPHQL_API_URL } from "@/constants";

const PRICING_QUERY = `
  query {
    getPricingList {
      code
      err
      msg
      __typename
    }
  }
`;

// Shared across every caller so the five service pages no longer each fire
// their own request for the very same catalog.
let inFlight = null;

export const actions = {
  async fetchCatalog({ commit, state }, { force = false } = {}) {
    if (state.loaded && !force) return state.catalog;
    if (inFlight && !force) return inFlight;

    commit("SET_LOADING", true);

    inFlight = (async () => {
      try {
        const response = await axios.post(GRAPHQL_API_URL, {
          query: PRICING_QUERY,
        });
        const result = response?.data?.data?.getPricingList;

        if (!result || result.code !== 200) {
          throw new Error(result?.err || "Could not load the pricing catalog");
        }

        commit("SET_CATALOG", result.msg);
        return result.msg;
      } catch (error) {
        console.error("Pricing catalog error:", error);
        commit("SET_ERROR", error.message || "Could not load pricing");
        throw error;
      } finally {
        inFlight = null;
      }
    })();

    return inFlight;
  },
};
